




































































































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import DateFormat from '@/shared/utils/date-format';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import RuleHistory from '@/domain/scripts/entity/rule-history.entity';
import RuleHistoryDetail from '@/domain/scripts/entity/rule-history-detail.entity';
import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import RuleVersionDiff from '@/domain/scripts/entity/rule-version-diff.entity';
import DiffLine from '@/domain/scripts/entity/diff-line.entity';
import RuleHistoryService from '@/domain/scripts/service/rule-history.service';
import Pagination from '@/domain/pagination.entity';
import Response from '@/domain/response.entity';
import AuthorityService from '@/domain/security/authority.service';

@Component({
  components: { ModalWarning, VbTooltipSlot, VbPagination },
  filters: {
    formatDateTime(value: string) {
      const date = DateFormat.timestampToLocal(moment(value).format('YYYY-MM-DD'));
      const time = moment(value).format('HH:mm');
      return `${date} ${time}`;
    },
  },
})
export default class RuleHistoryTab extends Vue {
  @Prop() businessUnitId!: string;

  @Prop() ruleId!: string;

  @Prop() currentVersion!: number | null;

  historyList: RuleHistory[] = [];

  loading: boolean = false;

  pagination: Pagination = new Pagination({
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'versionMajor|desc',
  });

  filter: { status: string | null; createdBy: string | null } = {
    status: null,
    createdBy: null,
  };

  filterDebounceTimeout: number | null = null;

  statusOptions = [
    { text: 'Rascunho', value: 'DRAFT' },
    { text: 'Publicado', value: 'PUBLISHED' },
    { text: 'Restaurado', value: 'RESTORED' },
  ];

  detail: RuleHistoryDetail | null = null;

  showDetailModal: boolean = false;

  diff: RuleVersionDiff | null = null;

  showDiffModal: boolean = false;

  showConfirmModal: boolean = false;

  confirmMessage: string = '';

  pendingAction: { type: 'publish' | 'restore'; version: string } | null = null;

  hasPanelCalculationsAuthority: boolean = false;

  headers = [
    { text: 'Versão', value: 'version', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Data', value: 'createdDate', sortable: false },
    { text: 'Usuário', value: 'createdBy', sortable: false },
    {
      text: '', value: 'actions', sortable: false, align: 'end',
    },
  ];

  created() {
    this.loadHistory();
    AuthorityService.authorities().then((authorities: string[]) => {
      this.hasPanelCalculationsAuthority = authorities.includes('PANEL_CALCULATIONS');
    }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  loadHistory() {
    if (!this.ruleId) return;
    this.loading = true;
    RuleHistoryService.getHistory(this.businessUnitId, this.ruleId, this.pagination, this.filter)
      .then((response: Response) => {
        this.historyList = RuleHistory.ofList(response.content);
        this.pagination.total = response.totalElements;
        this.pagination.pageCount = response.totalPages;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => { this.loading = false; });
  }

  onFilterChange() {
    this.pagination.page = 1;
    this.loadHistory();
  }

  onFilterChangeDebounced() {
    if (this.filterDebounceTimeout) clearTimeout(this.filterDebounceTimeout);
    this.filterDebounceTimeout = window.setTimeout(() => this.onFilterChange(), 400);
  }

  isCurrent(item: RuleHistory): boolean {
    return item.versionMajor === this.currentVersion && item.versionMinor === 0;
  }

  openDetail(version: string) {
    RuleHistoryService.getHistoryVersion(this.businessUnitId, this.ruleId, version)
      .then((detail: RuleHistoryDetail) => {
        this.detail = detail;
        this.showDetailModal = true;
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  loadIntoEditor(version: string) {
    RuleHistoryService.getHistoryVersion(this.businessUnitId, this.ruleId, version)
      .then((detail: RuleHistoryDetail) => {
        this.$emit('loadVersionIntoEditor', detail);
        VbSnackbarService.showSuccess(
          `Versão ${version} carregada no editor — revise e salve como rascunho`,
        );
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  hasPreviousVersion(item: RuleHistory): boolean {
    const index = this.historyList.findIndex((h: RuleHistory) => h.version === item.version);
    return index >= 0 && index < this.historyList.length - 1;
  }

  openDiff(item: RuleHistory) {
    const index = this.historyList.findIndex((h: RuleHistory) => h.version === item.version);
    const previous = this.historyList[index + 1];
    if (!previous) return;

    RuleHistoryService.diffVersions(
      this.businessUnitId, this.ruleId, previous.version, item.version,
    )
      .then((diff: RuleVersionDiff) => {
        this.diff = diff;
        this.showDiffModal = true;
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  askConfirmation(type: 'publish' | 'restore', version: string) {
    this.pendingAction = { type, version };
    this.confirmMessage = type === 'publish'
      ? `Deseja publicar a versão ${version}? Ela passará a ser o estado ativo do cálculo.`
      : `Deseja restaurar a versão ${version}? Isso cria uma nova versão com o conteúdo dela.`;
    this.showConfirmModal = true;
  }

  handleConfirm() {
    this.showConfirmModal = false;
    if (!this.pendingAction) return;

    const { type, version } = this.pendingAction;
    const action = type === 'publish'
      ? RuleHistoryService.publishVersion(this.businessUnitId, this.ruleId, version)
      : RuleHistoryService.restoreVersion(this.businessUnitId, this.ruleId, version);

    action.then((rule: RuleScript) => {
      VbSnackbarService.showSuccess(
        type === 'publish' ? 'Versão publicada com sucesso' : 'Versão restaurada com sucesso',
      );
      this.loadHistory();
      this.$emit('ruleUpdated', rule);
    }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  marker(line: DiffLine): string {
    if (line.isAdd) return '+';
    if (line.isDel) return '-';
    return ' ';
  }

  statusColor(item: RuleHistory): string {
    if (item.isDraft) return 'warning';
    if (item.isRestored) return 'bluePrimary';
    return 'greenPrimary';
  }
}
